import React from 'react';
import { Stack } from '@packages/ui/layout';
import type { FormStackNode } from '../../types/layout';
import { FormNodeRenderer } from '../FormNodeRenderer';

interface StackRendererProps {
  node: FormStackNode;
  namePrefix?: string;
}

export const FormStackRenderer = React.memo(function FormStackRenderer({ node, namePrefix }: StackRendererProps): React.ReactElement {
  return (
    <Stack gap={node.gap} semanticId={node.semanticId}>
      {node.children.map((child, idx) => (
        <FormNodeRenderer key={idx} node={child} namePrefix={namePrefix} />
      ))}
    </Stack>
  );
});
